import { Eye, Pencil, Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import React from "react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { ContentLayout } from "../../components/admin-panel/content-layout";
import Pagination from "../../components/Pagination";
import DeleteModal from "../../components/deleteModal";
import ModalPopUp from "../../components/ModalPopUp";

const adminData = [
  {
    id: "1",
    name: "Fenish Desai",
    mobile: "8888888888",
    email: "fenil@gmail.com",
    password: "*********",
  },
  {
    id: "2",
    name: "Ashish Kakadiya",
    mobile: "8888888888",
    email: "ashish@gmail.com",
    password: "*********",
  },
  {
    id: "3",
    name: "Rushikesh Bhayani",
    mobile: "8888888888",
    email: "rushikesh@gmail.com",
    password: "*********",
  },
];

const SuperAdmin = () => {
  return (
    <ContentLayout>
      <Card className="grid gap-5">
        <div className="flex items-center justify-between">
          <h1 className="font-semibold text-xl">Super Admin</h1>
          <ModalPopUp />
        </div>
        <Table className="rounded-lg overflow-hidden">
          <TableHeader>
            <TableRow className="bg-primary hover:bg-primary text-white">
              <TableHead className="w-[100px] text-white">No.</TableHead>
              <TableHead className="text-white">Name</TableHead>
              <TableHead className="text-white">Number</TableHead>
              <TableHead className="text-white">Email</TableHead>
              <TableHead className="text-white">Password</TableHead>
              <TableHead className="w-24 text-center text-white">
                Action
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {adminData.map((adminData) => (
              <TableRow key={adminData.adminData}>
                <TableCell>{adminData.id}</TableCell>
                <TableCell>{adminData.name}</TableCell>
                <TableCell>{adminData.mobile}</TableCell>
                <TableCell>{adminData.email}</TableCell>
                <TableCell>{adminData.password}</TableCell>
                <TableCell className="w-24">
                  <div className="flex items-center justify-center gap-2">
                    <div className="border rounded-md p-1 hover:bg-primary hover:border-[#7064E9] duration-200 cursor-pointer">
                      <Pencil className="h-4 w-4" />
                    </div>
                    <DeleteModal />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className="flex justify-end items-center">
          <Pagination />
        </div>
      </Card>
    </ContentLayout>
  );
};

export default SuperAdmin;
